/**
 * Ítem 3: venta con día cerrado → skip-forward + copy del modal.
 * El BE asigna la fecha; este helper es la preview FE (GET / cache).
 */
import { formatDateOnlyEsAR } from "@/lib/utils";
import { addDaysYmd } from "./cierreCarousel";
import {
  isCierreCerradoForSucursal,
  type CierreListItem,
} from "./facturaListCierreFilter";

export const FECHA_VENTA_MODAL_TITULO = "Día cerrado";

/** Copy locked: «Se creará con fecha dd/mm/aaaa». */
export function mensajeSeCrearaConFecha(ymd: string): string {
  return `Se creará con fecha ${formatDateOnlyEsAR(ymd)}.`;
}

/**
 * Primer día sin CierreDiario cerrado de esa sucursal.
 * Sin fila o abierto = esa fecha. Si fromYmd está cerrado, +1, +2, …
 */
export function nextFechaVentaYmd(
  cierres: CierreListItem[] = [],
  sucursalId: number | null,
  fromYmd: string,
  maxDays = 366,
): string {
  if (!fromYmd) return fromYmd;
  let ymd = fromYmd;
  for (let i = 0; i < maxDays; i += 1) {
    if (!isCierreCerradoForSucursal(cierres, ymd, sucursalId)) {
      return ymd;
    }
    ymd = addDaysYmd(ymd, 1);
  }
  return ymd;
}

export function ventaRequiereAvisoFecha(
  solicitadaYmd: string,
  aplicadaYmd: string,
): boolean {
  return Boolean(solicitadaYmd && aplicadaYmd && solicitadaYmd !== aplicadaYmd);
}
